import { HIDE_MODAL, SET_MODAL } from "../constants/modals";
import { Action, ModalsState } from "../models/modals";

const initialState = {
  modal: "",
  visible: false,
  data: null,
};
const modalsReducer = (state: ModalsState = initialState, action: Action): ModalsState => {
  switch (action.type) {
    case SET_MODAL:
      return action.payload;
    case HIDE_MODAL:
      return { ...state, visible: false };
    default:
      return state;
  }
};

export default modalsReducer;
